/*  ========================================================================
    # Scripts - Interactive Assistant
    ========================================================================  */

const InteractiveAssistant = {
  cfg: {
    assistantEntries: document.querySelectorAll('[data-entry]'),
    assistantTargets: document.querySelectorAll('[data-entry-target]')
  },

  /**
   * Handler.
   */
  handler() {
    this.cfg.assistantEntries.forEach(entry => {
      entry.addEventListener('click', () => {
        if (entry.getAttribute('aria-checked') === 'true') {
          // Remove active attribute from all entries and targets.
          entry.setAttribute('aria-checked', 'false');
          this.cfg.assistantTargets.forEach(target => {
            target.removeAttribute('data-active');
          });
        } else {
          // Remove active attribute from all entries and targets.
          this.cfg.assistantEntries.forEach(entry => {
            entry.setAttribute('aria-checked', 'false');
          });
          // Add active attribute to the clicked entry and its target.
          entry.setAttribute('aria-checked', 'true');
          this.cfg.assistantTargets.forEach(target => {
            if (entry.getAttribute('data-entry') === target.getAttribute('data-entry-target')) {
              target.setAttribute('data-active', '');
            } else {
              target.removeAttribute('data-active');
            }
          });
        }
      });
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.assistantEntries.length > 0) this.handler();
  }
};

export default InteractiveAssistant;
